import { render, staticRenderFns } from "./DeliveryNoteItemsTable.vue?vue&type=template&id=db481ca2&"
import script from "./DeliveryNoteItemsTable.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports